import React, {useEffect, useState} from "react";
import Box from "../../lib/appfuse-react/component/Box";
import Paper from "../../lib/appfuse-react/component/Paper";
import {TabContext, TabList, TabPanel} from "@material-ui/lab";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary, Dialog, DialogActions, DialogContent, Divider,
    Grid, List, ListItem, ListItemIcon,
    Tab,
    Typography
} from "@material-ui/core";
import CircularProgress from "../../lib/appfuse-react/component/CircularProgress";
import {useDispatch, useSelector} from "../../store";
import {isAuthenticated} from "../../reducer/iam/authReducer";
import {withDesktop} from "../../layout/Desktop";
import {withExplorer} from "../../layout/Explorer";
import i18n from "../../lib/appfuse-react/core/i18n";
import {makeStyles} from "@material-ui/core/styles";
import frequentlyAskedQuestionService from "../../service/frequentlyAskedQuestion/frequentlyAskedQuestionService";
import Icon from "../../lib/appfuse-react/component/Icon";
import Form from "../../lib/appfuse-react/component/Form";
import Address, {MobileAddress} from "../../component/Address";
import SelectField from "../../lib/appfuse-react/component/SelectField";
import valueChange from "../../component/Judge/ValueChange";
import reissueCertificateService from "../../service/reissueCertificate/reissueCertificateService";
import usePrompt from "../../lib/appfuse-react/hook/usePrompt";
import Button from "../../lib/appfuse-react/component/Button";
import lang from "../../lib/appfuse-react/core/lang";
import utilService from "../../service/util/utilService";
import {selectCounty, setCounty} from "../../reducer/util/utilReducer";
import Toolbar from "../../component/Toolbar";
import Space from "../../lib/appfuse-react/component/Space";
import Expander from "../../lib/appfuse-react/component/Expander";
import {ReactComponent as QaIcon} from "../../image/qa.svg";
import {useHistory} from "react-router-dom";
import TypographyWithLink from "../../component/TypographyWithLink";
import TextField from "../../lib/appfuse-react/component/TextField";
import {Close, ExpandMore, Star} from "@material-ui/icons";
import useResponsive from "../../lib/appfuse-react/hook/useResponsive";

const useStyles = makeStyles((theme) => ({
    tabPanel: {
        height: '100%',
        overflow: 'hidden',
        padding: '0px'
    },
    buttons: {
        '& > *:not(:last-child)': {
            marginRight: theme.spacing(1),
        }
    },
}));

function OtherInfoContent() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [ready, setReady] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const [frequentlyAskedQuestion, setFrequentlyAskedQuestion] = useState([]);
    const county = useSelector(selectCounty);

    useEffect(() => {
        (async () => {

            const frequentlyAskedQuestion = await frequentlyAskedQuestionService.findAll();
            setFrequentlyAskedQuestion(frequentlyAskedQuestion);

            if(lang.isEmpty(county)) {
                const data = await utilService.findCounty();
                dispatch(setCounty(data));
            }

            setReady(true);
        })();
    }, []);

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    const responsive = useResponsive();
    const isMobile = !responsive.isLargeScreen();
    const padding = isMobile? 0:4;

    return (
        <Box fullHeight fullWidth>
            <CircularProgress value={ready} fullWidth fullHeight backgroundColor='white'>
                <Paper fullHeight fullWidth square variant='outlined'>
                    <TabContext value={tabValue}>
                        <Box display='flex' flexDirection='column' fullHeight padding={padding}>
                            <Paper>
                                <TabList onChange={handleChangeTab} textColor='primary' style={{paddingTop: '1rem', paddingLeft: '2rem'}}>
                                    <Tab label={i18n.translate('Frequently Asked Question')}/>
                                    <Tab label={i18n.translate('Apply for Certificate Reissue')}/>
                                </TabList>
                            </Paper>
                            <Box fullWidth fullHeight overflow='hidden'>
                                <TabPanel value={0} className={classes.tabPanel}>
                                    <FrequentlyAskedQuestion value={frequentlyAskedQuestion}/>
                                </TabPanel>
                                <TabPanel value={1} className={classes.tabPanel}>
                                    <ReissueCertificate/>
                                </TabPanel>
                            </Box>
                        </Box>
                    </TabContext>
                </Paper>
            </CircularProgress>
        </Box>
    )
}

function FrequentlyAskedQuestion(props) {
    const {value=[]} = props;

    return (
        <Box fullWidth fullHeight display='flex' flexDirection='column' overflow='hidden' paddingY={2}>
            <Box fullWidth overflow='auto' paddingY={2} paddingX={2}>
                { value.map((item, index) => <CustomizedAccordion key={index} value={item}/>) }
            </Box>
        </Box>
    );
}

const useAccordionStyles = makeStyles((theme) => ({
    accordion: {
        border: `1px solid ${theme.palette.divider}`,
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
    },
    accordionSummary: {
        backgroundColor: 'rgba(0, 0, 0, .03)',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
    },
    accordionDetails: {
        padding: theme.spacing(2),
        borderTop: '1px solid rgba(0, 0, 0, .125)',
    }
}));

function CustomizedAccordion(props) {
    const classes = useAccordionStyles();
    const {value={}} = props;

    return (
        <Accordion className={classes.accordion}>
            <AccordionSummary expandIcon={<ExpandMore/>} className={classes.accordionSummary}>
                <Box paddingRight={2}><Icon><QaIcon/></Icon></Box>
                <Box paddingTop={0.5}>
                    <Typography style={{whiteSpace: 'pre-wrap'}}>{value.question}</Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails className={classes.accordionDetails}>
                <Box>
                    <Typography style={{whiteSpace: 'pre-wrap'}}>{value.answer}</Typography>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
}

function ReissueCertificate() {
    const prompt = usePrompt();
    const [value, setValue] = useState({});
    const [verifyOpen, setVerifyOpen] = useState(false);

    const handleChange = ({value}) => { setValue(value); };

    // 完成
    const complete = async () => {
        try {
            await reissueCertificateService.complete(value);
            prompt.confirm('Your certificate reissue request has been received and we will contact you as soon as possible.',
                {title:'Send the data successfully.', onAction: () => { setValue({}); }});
        } catch (e) {
            const dictionary = {chineseName:'Applicant Chinese Name', englishName:'Applicant English Name', mailingAddress:'Contact Address'};
            prompt.alert(e, {title:'Failed to send.', dictionary});
        }
    };

    // 送出
    const handleSend = async () => {
        try {
            // 檢查
            await reissueCertificateService.validate(value);

            // 已驗證 email
            if(value.valid) {
                await complete();
                return;
            }

            // 發送驗證碼
            await requestToken();
        } catch (e) {
            const dictionary = {chineseName:'Applicant Chinese Name', englishName:'Applicant English Name', mailingAddress:'Contact Address'};
            prompt.alert(e, {title:'Failed to send.', dictionary});
        }
    };

    const handleVerifyClose = () => { setVerifyOpen(false); };
    const requestToken = async () => {
        try {
            await reissueCertificateService.requestToken(value.email);
            setVerifyOpen(true);
            prompt.info('Open the email and find the verification code.');
        } catch(e) {
            prompt.alert('Failed to send the verification code.\nPlease try again later.');
        }
    }
    const verifyEmail = async (token) => {
        try {
            // email 驗證
            const valid = await reissueCertificateService.verifyEmail(value.email, token);
            if(valid) {
                setValue({...value, valid: true});
                setVerifyOpen(false);
                prompt.success('Verify successfully.');

                // 送出
                await complete();
            }
        } catch(e) {
            prompt.alert('Failed to verify the email.\nPlease try again later.');
        }
    }

    const responsive = useResponsive();
    const isMobile = !responsive.isLargeScreen();

    const CombinedStatement = isMobile? MobileStatement: Statement;
    const CombinedApply = isMobile? FormApplyMobile: FormApply;

    return (
        <Box fullWidth fullHeight display='flex' flexDirection='column' overflow='hidden' paddingY={2}>
            <Box fullWidth fullHeight overflow='hidden' paddingX={2}>
                <Box fullWidth fullHeight display='flex' flexDirection='column' overflow='hidden'>
                    <Box fullWidth overflow='auto' paddingY={2}>
                        <CombinedStatement/>
                        <CombinedApply value={value} onChange={handleChange}/>
                        <Box fullWidth paddingTop={1}>
                            <Typography><b>{i18n.translate('Apply for Certificate Reissue Statement 3')}</b></Typography>
                        </Box>
                    </Box>
                    <Box display='flex' justifyContent='end' paddingTop={2} paddingX={2}>
                        <Button text="Send" variant="contained" color="primary" onClick={handleSend} fullWidth/>
                    </Box>
                </Box>
                { verifyOpen && <VerifyEmail open={verifyOpen} onVerify={verifyEmail} onClose={handleVerifyClose}/> }
            </Box>
        </Box>
    );
}

function FormApplyMobile(props) {
    const {value, onChange = () => {}} = props;

    return (
        <Form value={value} onChange={onChange}>
            <Grid container spacing={2} item xs={12}>
                {/*申請者中文姓名*/}
                <Grid item xs={12}>
                    <TextField name='chineseName' label='Applicant Chinese Name' variant='outlined' fullWidth helperText='書寫範例：王小華' required/>
                </Grid>
                {/*申請者英文姓名*/}
                <Grid item xs={12}>
                    <TextField name='englishName' label='Applicant English Name' variant='outlined' fullWidth helperText='書寫範例：Ciao-Hua Wang' required/>
                </Grid>
                {/*電子郵件*/}
                <Grid item xs={12}>
                    <TextField name='email' label='Email' variant='outlined' fullWidth required/>
                </Grid>
                {/*發票抬頭*/}
                <Grid item xs={12}>
                    <TextField name='institution' label='Invoice title' variant='outlined' fullWidth/>
                </Grid>
                {/*統一編號*/}
                <Grid item xs={12}>
                    <TextField name='institutionTaxId' label='Tax Id No' variant='outlined' fullWidth/>
                </Grid>
                {/*聯絡電話*/}
                <Grid item xs={12}>
                    <TextField name='contactPhone' label='Contact Telephone' variant='outlined' fullWidth required/>
                </Grid>
                {/*課程日期*/}
                <Grid item xs={12}>
                    <TextField name='courseDate' label='Class Date' variant='outlined' fullWidth helperText='2020/03/05-2020/03/07' />
                </Grid>
                {/*證書號碼*/}
                <Grid item xs={12}>
                    <TextField name='certificateNo' label='Certificate No' variant='outlined' fullWidth/>
                </Grid>
                <Grid item xs={12}/>
                {/*補發原因*/}
                <Grid item xs={12}>
                    <SelectField name='reissueReason' label='Reissue Reason' code='reissueReason' variant='outlined' fullWidth required/>
                </Grid>
                {
                    valueChange.isEqualCmp(value.reissueReason, 'others') && (
                        <Grid item xs={4}>
                            {/*其他補發原因*/}
                            <TextField name='reissueReasonOtherDesc' label='Other Reissue Reason' variant='outlined' fullWidth required/>
                        </Grid>
                    )
                }
                {/*聯絡地址*/}
                <Grid item xs={12}>
                    <MobileAddress type='object' name='mailingAddress' subtitle='Contact Address' variant='outlined' required withoutCountry/>
                </Grid>
            </Grid>
        </Form>
    )
}

function FormApply(props) {
    const {value, onChange = () => {}} = props;

    return (
        <Form value={value} onChange={onChange}>
            <Grid container spacing={2} item xs={12}>
                {/*申請者中文姓名*/}
                <Grid item xs={4}>
                    <TextField name='chineseName' label='Applicant Chinese Name' variant='outlined' fullWidth helperText='書寫範例：王小華' required/>
                </Grid>
                {/*申請者英文姓名*/}
                <Grid item xs={4}>
                    <TextField name='englishName' label='Applicant English Name' variant='outlined' fullWidth helperText='書寫範例：Ciao-Hua Wang' required/>
                </Grid>
                {/*電子郵件*/}
                <Grid item xs={4}>
                    <TextField name='email' label='Email' variant='outlined' fullWidth required/>
                </Grid>
                {/*發票抬頭*/}
                <Grid item xs={4}>
                    <TextField name='institution' label='Invoice title' variant='outlined' fullWidth/>
                </Grid>
                {/*統一編號*/}
                <Grid item xs={4}>
                    <TextField name='institutionTaxId' label='Tax Id No' variant='outlined' fullWidth/>
                </Grid>
                {/*聯絡電話*/}
                <Grid item xs={4}>
                    <TextField name='contactPhone' label='Contact Telephone' variant='outlined' fullWidth required/>
                </Grid>
                {/*課程日期*/}
                <Grid item xs={4}>
                    <TextField name='courseDate' label='Class Date' variant='outlined' fullWidth helperText='2020/03/05-2020/03/07' />
                </Grid>
                {/*證書號碼*/}
                <Grid item xs={4}>
                    <TextField name='certificateNo' label='Certificate No' variant='outlined' fullWidth/>
                </Grid>
                <Grid item xs={4}/>
                {/*補發原因*/}
                <Grid item xs={4}>
                    <SelectField name='reissueReason' label='Reissue Reason' code='reissueReason' variant='outlined' fullWidth required/>
                </Grid>
                {
                    valueChange.isEqualCmp(value.reissueReason, 'others') && (
                        <Grid item xs={4}>
                            {/*其他補發原因*/}
                            <TextField name='reissueReasonOtherDesc' label='Other Reissue Reason' variant='outlined' fullWidth required/>
                        </Grid>
                    )
                }
                {/*聯絡地址*/}
                <Grid item xs={12}>
                    <Address type='object' name='mailingAddress' subtitle='Contact Address' variant='outlined' required withoutCountry/>
                </Grid>
            </Grid>
        </Form>
    )
}

function VerifyEmail(props) {
    const classes = useStyles();
    const {open} = props;
    const [token, setToken] = useState("");

    const handleChange = (event) => {
        const {value} = event.target;
        setToken(value);
    };

    const handleVerify = async () => {
        props.onVerify(token);
    };

    return (
        <Dialog open={open} maxWidth='xs' fullWidth>
            <Toolbar>
                <Space spacing={1}/>
                <Typography variant='h6'>{i18n.translate('Verify Email')}</Typography>
                <Expander/>
                <Button icon={<Close/>}  variant="icon"  onClick={props.onClose}/>
            </Toolbar>
            <DialogContent>
                <TextField value={token} label={i18n.translate('Verification Code')} fullWidth variant='outlined' onChange={handleChange}/>
            </DialogContent>
            <DialogActions>
                <Box display='flex' className={classes.buttons}>
                    <Button text="Verify" variant="contained" color="primary" onClick={handleVerify} fullWidth />
                    <Button text="Cancel" variant="contained" color="primary" onClick={props.onClose} fullWidth />
                </Box>
            </DialogActions>
        </Dialog>
    );
}

const useStatementStyles = makeStyles((theme) => ({
    paper: {
        boxShadow: theme.shadows[3],
        borderRadius: '0.5rem',
    }
}));

function MobileStatement() {
    const history = useHistory();
    const classes = useStatementStyles();

    const contactUs = [
        "Apply for Certificate Reissue Statement 2-1-1",
        {
            text: 'Contact Us',
            onClick: () => { history.push('/contactUs') },
        },
        "Apply for Certificate Reissue Statement 2-1-2"
    ];

    return (
        <Box gap={1} fullWidth>
            <List dense>
                <ListItem>
                    <Box display='flex'>
                        <ListItemIcon style={{minWidth:'2rem', paddingTop:2}}><Star color='primary' fontSize='small'/></ListItemIcon>
                        <Typography>{i18n.translate('Apply for Certificate Reissue Statement 1')}</Typography>
                    </Box>
                </ListItem>
                <ListItem>
                    <Box display='flex'>
                        <ListItemIcon style={{minWidth:'2rem', paddingTop:2}}><Star color='primary' fontSize='small'/></ListItemIcon>
                        <Typography>{i18n.translate('Apply for Certificate Reissue Statement 2')}</Typography>
                    </Box>
                </ListItem>
                <ListItem>
                    <ListItemIcon style={{minWidth:'1rem'}}/>
                    <List dense>
                        <ListItem>
                            <Box display='flex'>
                                <ListItemIcon style={{minWidth:'2rem', paddingTop:2}}>1.</ListItemIcon>
                                <TypographyWithLink data={contactUs}/>
                            </Box>
                        </ListItem>
                        <ListItem>
                            <Box display='flex'>
                                <ListItemIcon style={{minWidth:'2rem', paddingTop:2}}>2.</ListItemIcon>
                                <Typography>{i18n.translate('Apply for Certificate Reissue Statement 2-2')}</Typography>
                            </Box>
                        </ListItem>
                        <ListItem>
                            <Box display='flex'>
                                <ListItemIcon style={{minWidth:'2rem', paddingTop:2}}>3.</ListItemIcon>
                                <Typography>{i18n.translate('Apply for Certificate Reissue Statement 2-3-Mobile')}</Typography>
                            </Box>
                        </ListItem>
                    </List>
                </ListItem>
            </List>

            <Box padding={2}>
                <Paper fullHeight padding={2} className={classes.paper} >
                    <CustomizedTypography label='Name of Land Bank of Taiwan' value='Apply for Certificate Reissue Statement 2-3-1'/>
                    <Divider/>
                    <CustomizedTypography label='Bank Code' value='Apply for Certificate Reissue Statement 2-3-2'/>
                    <Divider/>
                    <CustomizedTypography label='Account Name' value='Apply for Certificate Reissue Statement 2-3-3'/>
                    <Divider/>
                    <CustomizedTypography label='Account' value='Apply for Certificate Reissue Statement 2-3-4'/>
                </Paper>
            </Box>
        </Box>
    )
}

function Statement() {
    const history = useHistory();
    const classes = useStatementStyles();

    const contactUs = [
        "Apply for Certificate Reissue Statement 2-1-1",
        {
            text: 'Contact Us',
            onClick: () => { history.push('/contactUs') },
        },
        "Apply for Certificate Reissue Statement 2-1-2"
    ];

    return (
        <Box display='flex' gap={1} fullWidth paddingRight={2}>
            <Box paddingBottom={2}>
                <List dense>
                    <ListItem>
                        <Box display='flex'>
                            <ListItemIcon style={{minWidth:'2rem', paddingTop:2}}><Star color='primary' fontSize='small'/></ListItemIcon>
                            <Typography>{i18n.translate('Apply for Certificate Reissue Statement 1')}</Typography>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box display='flex'>
                            <ListItemIcon style={{minWidth:'2rem', paddingTop:2}}><Star color='primary' fontSize='small'/></ListItemIcon>
                            <Typography>{i18n.translate('Apply for Certificate Reissue Statement 2')}</Typography>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <ListItemIcon style={{minWidth:'1rem'}}/>
                        <List dense>
                            <ListItem>
                                <Box display='flex'>
                                    <ListItemIcon style={{minWidth:'2rem', paddingTop:2}}>1.</ListItemIcon>
                                    <TypographyWithLink data={contactUs}/>
                                </Box>
                            </ListItem>
                            <ListItem>
                                <Box display='flex'>
                                    <ListItemIcon style={{minWidth:'2rem', paddingTop:2}}>2.</ListItemIcon>
                                    <Typography>{i18n.translate('Apply for Certificate Reissue Statement 2-2')}</Typography>
                                </Box>
                            </ListItem>
                            <ListItem>
                                <Box display='flex'>
                                    <ListItemIcon style={{minWidth:'2rem', paddingTop:2}}>3.</ListItemIcon>
                                    <Typography>{i18n.translate('Apply for Certificate Reissue Statement 2-3')}</Typography>
                                </Box>
                            </ListItem>
                        </List>
                    </ListItem>
                </List>
            </Box>

            <Paper minWidth='22rem' maxWidth='22rem' fullHeight padding={3} className={classes.paper} >
                <CustomizedTypography label='Name of Land Bank of Taiwan' value='Apply for Certificate Reissue Statement 2-3-1'/>
                <Divider/>
                <CustomizedTypography label='Bank Code' value='Apply for Certificate Reissue Statement 2-3-2'/>
                <Divider/>
                <CustomizedTypography label='Account Name' value='Apply for Certificate Reissue Statement 2-3-3'/>
                <Divider/>
                <CustomizedTypography label='Account' value='Apply for Certificate Reissue Statement 2-3-4'/>
            </Paper>
        </Box>
    );
}

function CustomizedTypography(props) {
    const {value, label} = props;

    return (
        <Box display='flex' justifyContent='flex-start' alignItems='center' paddingY={0.8}>
            <Box minWidth='7.3rem'>
                <Typography><b>{i18n.translate(label)}</b>：</Typography>
            </Box>
            <Box>
                <Typography>{i18n.translate(value)}</Typography>
            </Box>
        </Box>
    );
}

function OtherInfo() {
    const authenticated = useSelector(isAuthenticated);

    return authenticated? withDesktop(OtherInfoContent)():withExplorer(OtherInfoContent)();
}

export default OtherInfo;